<template>
  <div class="merchant-detail-container">
    <img :src="designerBj" alt="" v-if="!$isMobile" width="100%"/>
    <div class="--detail-merchant" :class="{'web-height':!$isMobile}">
      <div>
        <template v-if="!$isMobile">
          <div class="designer-details">
            <span>
              <p>关注</p>
              <h5>2</h5>
            </span>
            <span>
              <p>留言</p>
              <h5>2</h5>
            </span>
            <span v-if="detail">
              <img  :src="detail.avatar" alt="" class="img"/>
              <div class="text__name">{{ detail.nickname }}</div>
              <b class="focus">已关注</b>
            </span>
            <span>
              <p>评论</p>
              <h5>2</h5>
            </span>
            <span>
              <p>动态</p>
              <h5>2</h5>
            </span>
          </div>
        </template>
        <template v-else>
          <div class="mobile-detail-parameters-container">
            <div class="detail-designer-info detail__child">
              <div class="store-logo">
                <div class="__logo" v-if="detail">
                  <img
                  :src="detail.avatar"
                  alt="" />
                </div>
              </div>
              <div class="store-info">
                <div class="info__item">{{ detail.nickname }}</div>
                <div class="focus">
                  已关注
                </div>
              </div>
            </div>
            <div class="designer-child">
              <div class="info__list">
                <span>
                  <p>关注</p>
                  <h5>2</h5>
                </span>
                <span>
                  <p>留言</p>
                  <h5>2</h5>
                </span>
                <span>
                  <p>评论</p>
                  <h5>2</h5>
                </span>
                <span>
                  <p>动态</p>
                  <h5>2</h5>
                </span>
              </div>
              <div class="info__other">
                <p><span>电话：</span>{{ detail.phone }}</p>
                <p><span>邮箱：</span>{{ detail.email }}</p>
                <p><span>网址：</span>{{ detail.address }}</p>
                <p><span>公司：</span>{{ detail.company }}</p>
               <p><span>地址：</span>{{ detail.address }}</p>
                <p :class="{'show-one':isShowOne == true}"><span>简介：</span>这个是简介这个是简介这个是简介这个是简介这个是简介这个是简介这个是简介这个是简介</p>
                <h5 @click="changeIsShowOne" v-if='isShowOne == true'>展开</h5>
                <h5 @click="changeIsShowOne" v-if='isShowOne == false'>收起</h5>
              </div>
            </div>
          </div>
        </template>
      </div>

    </div>
    <div class="detail-container__main-body">
      <div class="main-body__nav-container">
        <div class="nav-container__wrapper">
          <router-link
            :to="nav.url"
            class="nav-item"
            v-for="(nav, index) in designerNav"
            :key="index"
            active-class="merchant-link-active"
            >{{ nav.name }}{{nav.sign}} <b v-if="(index + 1) != designerNav.length">（{{ counts[nav.sign] }}）</b></router-link
          >
        </div>
      </div>
      <div class="main-body__main-info-container">
        <p>456</p>
        <router-view :detail="detail"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import { parseImage } from '@/filters';
import { mapState } from 'vuex';
import { checkoutLogin } from '@/assets/utils/handler';

import { userActionLog } from '@/api/user';
import { USER_ACTION_MAP } from '@/assets/utils/dict';
import DetailSwiper from '@/pages/common/detailSwiper.vue';

import designerBj from '@/assets/images/designer_bj.png';

export default {
  components: {
    Swiper,
    SwiperSlide,
    DetailSwiper,
  },
  data() {
    return {
      isShowOne: false,
      designerBj,
      stars: 5,
      infoShow: true,
      detail: null,
      cases: null,
      produsts: null,
      samples: null,
      articles: null,
      relatedCases: null,
      swiperOptions: {
        autoplay: true,
        speed: 700,
        centeredSlides: true,
        spaceBetween: 0,
        slidesOffsetBefore: 0,
        loop: true,
        slidesPerView: 'auto',
        navigation: {
          nextEl: '.swiper__direction-bts .--next',
          prevEl: '.swiper__direction-bts .--prev',
        },
        on: {
          init() {
            const bodyBCR = document.body.getBoundingClientRect();
            const aBCR = document.querySelector('.swiper-slide-active').getBoundingClientRect();
            const directBts = Array.from(document.querySelectorAll('.bts__item'));
            const width = Math.floor((bodyBCR.width - aBCR.width) / 2);
            for (let i = 0; i < directBts.length; i += 1) {
              directBts[i].style.width = `${width}px`;
            }
            directBts[1].style.left = `${width + aBCR.width}px`;
          },
        },
      },
      swiper: null,
      counts: {
        cases: 0,
        demand: 0,
        idid: 0,
        dynamics: 0,
      },
      pageSize: 15,
    };
  },

  computed: mapState({
    cities: (state) => state.cities,
    userInfo: ({ user: { info } }) => info,
    pageLoading: (state) => state.pageloading,
    designerNav() {
      if (this.$isMobile === true) {
        return [
          {
            name: '案例',
            url: `/designer/${this.id}/cases`,
            sign: 'cases',
          },
          {
            name: '动态',
            url: `/designer/${this.id}/dynamics`,
            sign: 'dynamics',
          },
          {
            name: '需求',
            url: `/designer/${this.id}/demand`,
            sign: 'demand',
          },
        ];
      }
      return [
        {
          name: '案例',
          url: `/designer/${this.id}/cases`,
          sign: 'cases',
        },
        {
          name: '动态',
          url: `/designer/${this.id}/dynamics`,
          sign: 'dynamics',
        },
        {
          name: '需求',
          url: `/designer/${this.id}/demand`,
          sign: 'demand',
        },
        {
          name: '联系我',
          url: `/designer/${this.id}/contact`,
          sign: 'contact',
        },
      ];
      return [];
    },
    id() {
      return this.$route.params.id;
    },

    type() {
      return this.$route.params.type;
    },
    page() {
      return this.$route.query.page || 1;
    },
    belongLocal() {
      const provIds = this.detail.prov_id.indexOf(',') >= 0
        ? this.detail.prov_id.split(',')
        : [this.detail.prov_id];
      if (this.cities) {
        const prov = Number(this.detail.prov_id) === 0
          ? ['全国']
          : provIds.map((item) => {
            const temp = this.cities.find((c) => Number(c.id) === Number(item));
            return temp.name;
          });
        return prov;
      }
      return [];
    },
  }),
  watch: {
    $route: {
      handler() {
        this.getmore();
      },
      immediate: true,
    },
    id: {
      handler() {
        this.init();
      },
      immediate: true,
    },
    detail(val) {
      if (val && val.user_id && val.user_id > 0) {
        this.getDynamic({
          id: val.user_id,
          page: this.page,
          page_size: this.pageSize,
        });
      }
    },
    // pageLoading(val) {
    //   const that = this;
    //   if (val) {
    //     that.$refs.merchantDetailSwiper.$swiper.destroy();
    //   } else {
    //     that.$nextTick(() => {
    //       that.$refs.merchantDetailSwiper.$swiper.init();
    //     });
    //   }
    // },
  },
  created() {
    // this.init();
  },
  mounted() {
    const that = this;
    this.$nextTick(() => {
      const header = document.querySelector('.header-wrapper-container');
      if (that && that.type === 1) {
        header.classList.add('isFixed');
      }
    });
  },
  updated() {
    // const that = this;
    // this.$nextTick(() => {
    //   console.log(window.innerWidth, document.body.clientWidth, document.body.offsetWidth);
    //   console.log(document.querySelector('.page-common-main-container').getBoundingClientRect());
    //   that.$refs.merchantDetailSwiper.$swiper.init();
    // that.initD();
    // });
  },
  destroyed() {},
  methods: {
    initD() {
      const bodyBCR = document.body.getBoundingClientRect();
      const aBCR = document.querySelector('.swiper-slide-active').getBoundingClientRect();
      const directBts = Array.from(document.querySelectorAll('.bts__item'));
      const width = Math.floor((bodyBCR.width - aBCR.width) / 2);
      for (let i = 0; i < directBts.length; i += 1) {
        directBts[i].style.width = `${width}px`;
      }
      directBts[1].style.left = `${width + aBCR.width}px`;
    },
    changeIsShowOne() {
      this.isShowOne = this.isShowOne == false;
    },
    init() {
      this.detail = null;
      // 获取第一批数据
      this.$store.commit('openLoading');
      const pagination = {
        id: this.id,
        page: this.page,
        page_size: this.pageSize,
      };
      const requests = [
        this.getDetail(),
        this.getCases(pagination),
        this.getDynamic(pagination),
        this.getDemand(pagination),
      ];
      this.$http
        .multi(requests)
        .then((res) => {
          this.detail = res['0'].data;
          this.counts.cases = res['1'].data.total.num;
          this.counts.dynamics = res['2'].data.total.num;
          this.counts.demand = res['3'].data.total.num;
        })
        .finally(() => {
          this.$store.commit('closeLoading');
        });
    },
    bgUrl(val) {
      return parseImage(val);
    },
    getmore() {
      console.log('getmore');
    },
    getDetail() {
      return this.$http.post('html/Publiccon/businessCard', {
        id: this.id,
        store_id: '',
      });
    },
    getCases(data) {
      return this.$http.post('html/Publiccon/businessCase', data);
    },
    getDemand(data) {
      return this.$http.post('html/Publiccon/businessCase', data);
    },
    getDynamic(data) {
      return this.$http.post('html/Publiccon/businessCase', data);
    },
    onClaim() {
      userActionLog({
        type: USER_ACTION_MAP.auth,
      });
      checkoutLogin();
    },
    checkoutphone() {
      checkoutLogin();
    },
  },
};
</script>

<style></style>
